module.exports = __webpack_public_path__ + "img/Trillionaire-6.f9503b32.png";